import React from "react";
import PropTypes from "prop-types";
import { useBreakpoints } from "@qgiv/core-react";
import {
    ConnectedMobileRegistrationSummary,
    ConnectedRegistrationFooter,
    ConnectedRegistrationHeader,
    ConnectedRegistrationNav,
    ConnectedRegistrationSummary,
    ConnectedReturningRegistrationBanner,
    ConnectedFCRegistrationBanner,
    RegistrationContent,
} from ".";
import "./RegistrationBase.scss";
import ConnectedCurrentRegistrationNav from "./CurrentRegistrationNav/ConnectedCurrentRegistrationNav";

const RegistrationBase = ({ children, displayNav = true }) => {
    const { isMediumScreen } = useBreakpoints();

    return (
        <section className="registration">
            <div className="registration__inner">
                <div className="registration__content">
                    <div className="ordered-content">
                        <div className="ordered-content__section ordered-content__section--1">
                            <ConnectedRegistrationHeader
                                isMediumScreen={isMediumScreen}
                            />
                        </div>
                        {displayNav && (
                            <div className="ordered-content__section ordered-content__section--2">
                                <ConnectedRegistrationNav
                                    isMediumScreen={isMediumScreen}
                                />
                                <ConnectedCurrentRegistrationNav
                                    isMediumScreen={isMediumScreen}
                                />
                            </div>
                        )}
                        {isMediumScreen && (
                            <div className="ordered-content__section ordered-content__section--3">
                                <ConnectedMobileRegistrationSummary />
                            </div>
                        )}
                        <div className="ordered-content__section ordered-content__section--4">
                            <RegistrationContent>
                                <ConnectedReturningRegistrationBanner />
                                <ConnectedFCRegistrationBanner />
                                {children}
                            </RegistrationContent>
                        </div>
                        <div className="ordered-content__section ordered-content__section--5">
                            <ConnectedRegistrationFooter />
                        </div>
                    </div>
                </div>
                {/* Summary is hidden here, and displayed
                    within first column on smaller screens */}
                {!isMediumScreen && (
                    <aside className="registration__summary-aside">
                        <ConnectedRegistrationSummary displayHeader={true} />
                    </aside>
                )}
            </div>
        </section>
    );
};

RegistrationBase.propTypes = {
    children: PropTypes.any,
    displayNav: PropTypes.bool,
};

export default RegistrationBase;
